module.exports = __webpack_public_path__ + "img/dashboard-owners.d6bb210c.jpeg";